import { useSheetStore } from '@/shared/stores/sheet-store';
import { SheetPanel } from '@/shared/ui/panels/sheet-panel';

import { ClientDetailsChart } from './client-details-sheet/client-details-chart';

export function ClientDetailsSheet() {
    const currentSheet = useSheetStore((state) => state.currentSheet);
    const client = currentSheet?.type === 'clients/details' ? currentSheet.data : undefined;

    return (
        <SheetPanel
            type="clients/details"
            side="right"
            size="medium"
            variant="chart"
            showCloseButton={false}
        >
            <ClientDetailsChart client={client} />
        </SheetPanel>
    );
}
